import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-link.tsx
/**
* icon.24.link
*
* Keywords: chain, hyperlink, connection, attach, url, diagonal, oblique, tilted
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyLjQ0NCAxMC4zN2EyLjk5OCAyLjk5OCAwIDAgMSAuNjc3IDQuNzVsLTIgMmEzIDMgMCAxIDEtNC4yNDMtNC4yNDJsMS4yNy0xLjI3Yy4yNjItLjI2My43NDYtLjA2OS44MjYuMjkzYS40NC40NCAwIDAgMS0uMTExLjQwNWwtMS4yNzggMS4yNzlhMiAyIDAgMSAwIDIuODI5IDIuODI4bDItMmEyIDIgMCAwIDAgMC0yLjgyOGwtLjAyOS0uMDI4Yy0uMDkzLS4wODktLjE4Ny0uMTg0LS4yMjQtLjMwN2EuODguODggMCAwIDEgLjIyLS44Ny4wNS4wNSAwIDAgMSAuMDYzLS4wMW0uNDM0LTMuNDkyYTMgMyAwIDEgMSA0LjI0MyA0LjI0MmwtMS4yNyAxLjI3Yy0uMjYyLjI2Mi0uNzQ1LjA2OC0uODI2LS4yOTRhLjQ0LjQ0IDAgMCAxIC4xMTEtLjQwNWwxLjI3OC0xLjI3OGEyIDIgMCAxIDAtMi44MjktMi44MjhsLTIgMmEyIDIgMCAwIDAgMCAyLjgyOGwuMDI5LjAyNmMuMDkzLjA4OS4xODYuMTgzLjIyMy4zMDZhLjg4Ljg4IDAgMCAxLS4yMTguODc0LjA1LjA1IDAgMCAxLS4wNjIuMDA5IDMgMyAwIDAgMS0uNjc5LTQuNzV6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-872
*/
const Icon24Link = memo(function Icon24Link(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M12.444 10.37a2.998 2.998 0 0 1 .677 4.75l-2 2a3 3 0 1 1-4.243-4.242l1.27-1.27c.262-.263.746-.069.826.293a.44.44 0 0 1-.111.405l-1.278 1.279a2 2 0 1 0 2.829 2.828l2-2a2 2 0 0 0 0-2.828l-.029-.028c-.093-.089-.187-.184-.224-.307a.88.88 0 0 1 .22-.87.05.05 0 0 1 .063-.01m.434-3.492a3 3 0 1 1 4.243 4.242l-1.27 1.27c-.262.262-.745.068-.826-.294a.44.44 0 0 1 .111-.405l1.278-1.278a2 2 0 1 0-2.829-2.828l-2 2a2 2 0 0 0 0 2.828l.029.026c.093.089.186.183.223.306a.88.88 0 0 1-.218.874.05.05 0 0 1-.062.009 3 3 0 0 1-.679-4.75z"
		})
	});
});
//#endregion
export { Icon24Link };

//# sourceMappingURL=icon-24-link.js.map